import axiosInstance from '../../../axiosInstance';
import apiEndpoints from '../../../api';
import { notify, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS } from '../../../../utils/notification';

// Covers both envelope shapes: business { success:false,message } and validation { status:"error",message }.
const errMsg = (err, fallback) => err?.response?.data?.message || err?.message || fallback;

const clean = (obj) => {
    const out = {};
    Object.keys(obj || {}).forEach((k) => {
        const v = obj[k];
        if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
};

export const getSystemRolesReq = (action) => {
    const d = action.data || {};
    const params = clean({
        page: d.page,
        limit: d.limit || 100,
        is_active: d.is_active,
        is_system_role: d.is_system_role ?? 1,
    });
    return axiosInstance.get(apiEndpoints.CTRL_SYS_ROLES_LIST_API, { params })
        .then(res => res)
        .catch((err) => { notify(NOTIFICATION_TYPE_ERROR, errMsg(err, 'Failed to load roles')); return err; });
};

export const getSystemRoleDetailsReq = (action) => {
    const url = apiEndpoints.CTRL_SYS_ROLE_DETAILS_API.replace(':id', action.data.id);
    return axiosInstance.get(url)
        .then(res => res)
        .catch((err) => { notify(NOTIFICATION_TYPE_ERROR, errMsg(err, 'Failed to load role')); return err; });
};

export const getPermissionCatalogReq = (action) => {
    const d = action.data || {};
    const params = clean({
        all_modules: d.all_modules ?? 1,
        limit: d.limit || 500,
        module: d.module,
        resource: d.resource,
        is_active: d.is_active,
    });
    return axiosInstance.get(apiEndpoints.CTRL_SYS_PERMISSION_CATALOG_API, { params })
        .then(res => res)
        .catch((err) => { notify(NOTIFICATION_TYPE_ERROR, errMsg(err, 'Failed to load permissions')); return err; });
};

export const createSystemRoleReq = (action) => {
    const { onSuccess, onError, ...payload } = action.data || {};
    return axiosInstance.post(apiEndpoints.CTRL_SYS_ROLE_CREATE_API, clean(payload))
        .then((res) => {
            if (res?.success) notify(NOTIFICATION_TYPE_SUCCESS, res.message || 'Role created successfully');
            return res;
        })
        .catch((err) => { notify(NOTIFICATION_TYPE_ERROR, errMsg(err, 'Failed to create role')); return err; });
};

export const updateSystemRoleReq = (action) => {
    const { id, onSuccess, onError, ...payload } = action.data || {};
    const url = apiEndpoints.CTRL_SYS_ROLE_UPDATE_API.replace(':id', id);
    // role_code is immutable — never send it on update.
    delete payload.role_code;
    return axiosInstance.put(url, clean(payload))
        .then((res) => {
            if (res?.success) notify(NOTIFICATION_TYPE_SUCCESS, res.message || 'Role updated successfully');
            return res;
        })
        .catch((err) => { notify(NOTIFICATION_TYPE_ERROR, errMsg(err, 'Failed to update role')); return err; });
};

export const setSystemRolePermissionsReq = (action) => {
    const { id, permission_ids } = action.data || {};
    const url = apiEndpoints.CTRL_SYS_ROLE_SET_PERMISSIONS_API.replace(':id', id);
    return axiosInstance.put(url, { permission_ids: permission_ids || [] })
        .then((res) => {
            if (res?.success) notify(NOTIFICATION_TYPE_SUCCESS, res.message || 'Permissions saved successfully');
            return res;
        })
        .catch((err) => { notify(NOTIFICATION_TYPE_ERROR, errMsg(err, 'Failed to save permissions')); return err; });
};

export const deactivateSystemRoleReq = (action) => {
    const url = apiEndpoints.CTRL_SYS_ROLE_DELETE_API.replace(':id', action.data.id);
    return axiosInstance.delete(url)
        .then((res) => {
            if (res?.success) notify(NOTIFICATION_TYPE_SUCCESS, res.message || 'Role deactivated successfully');
            return res;
        })
        .catch((err) => { notify(NOTIFICATION_TYPE_ERROR, errMsg(err, 'Failed to deactivate role')); return err; });
};
